import React, { useState, useEffect, useRef, useCallback } from "react"
import { genDeck } from "./"
import audio from "../utils/audio"
import Card from "../components/Card"

function useGame(bg, data) {
  const deckItems = data.game.frontmatter.cards.map(({ image }) => image)

  const cardsHorizontal = data.game.frontmatter.cardsHorizontal
  const cardsVertical = data.game.frontmatter.cardsVertical

  let randomChoose = []

  function randomReduced() {
    randomChoose = []
    let x = parseInt(cardsHorizontal)
    let y = parseInt(cardsVertical)

    let nCards = deckItems.length
    if (x > 0 && y > 0) {
      nCards = (x * y) / 2 // x * y /2
    }
    //console.log("nCards: "+nCards);
    let allNumbers = []
    for (let i = 0; i < deckItems.length; i++) {
      allNumbers.push(i)
    }
    //console.log("allNumbers: ",allNumbers);
    for (let i = 0; i < nCards; i++) {
      const r = Math.floor(Math.random() * allNumbers.length)
      //console.log("r: "+r+" allNumbers[r]: "+allNumbers[r]);
      randomChoose.push(allNumbers[r])
      allNumbers.splice(r, 1)
    }
    console.log("randomChoose: ", randomChoose)
  }

  function reduceDeck(deck) {
    if (randomChoose.length == 0) randomReduced()
    let outDeck = []
    for (let i = 0; i < deck.length; i++) {
      if (randomChoose.includes(i)) {
        outDeck.push(deck[i])
      }
    }
    //console.log("outDeck: ",outDeck);
    return outDeck
  }

  const [errors, setErrors] = useState(0)
  /*
  const [elapsedTime, setElapsedTime] = useState(0);
  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setElapsedTime(elapsedTime => elapsedTime + 0.1);
    }, 100);
    return () => clearInterval(interval);
  }, [elapsedTime]);
*/
  const [matches, setMatch] = useState([])
  const [flipping, setFlip] = useState({ i: [], v: [] })
  const [deck, setDeck] = useState(genDeck(reduceDeck(deckItems)))
  const [hasError, setHasError] = useState(false)
  const timeoutEntriesRef = useRef([])

  const runTimeout = useCallback((entry) => {
    entry.startedAt = performance.now()
    entry.timeoutId = setTimeout(() => {
      timeoutEntriesRef.current = timeoutEntriesRef.current.filter(
        (currentEntry) => currentEntry !== entry
      )
      entry.timeoutId = null
      entry.startedAt = null
      entry.callback()
    }, entry.remainingMs)
  }, [])

  const scheduleTimeout = useCallback(
    (callback, delay) => {
      const entry = {
        callback,
        remainingMs: delay,
        startedAt: null,
        timeoutId: null,
      }

      timeoutEntriesRef.current.push(entry)
      if (
        typeof document === "undefined" ||
        document.visibilityState !== "hidden"
      ) {
        runTimeout(entry)
      }

      return entry
    },
    [runTimeout]
  )

  const clearAllTimeouts = useCallback(() => {
    timeoutEntriesRef.current.forEach((entry) => {
      if (entry.timeoutId !== null) {
        clearTimeout(entry.timeoutId)
      }
    })
    timeoutEntriesRef.current = []
  }, [])

  const pauseTimeouts = useCallback(() => {
    const now = performance.now()
    timeoutEntriesRef.current.forEach((entry) => {
      if (entry.timeoutId === null || entry.startedAt === null) {
        return
      }

      entry.remainingMs = Math.max(
        0,
        entry.remainingMs - (now - entry.startedAt)
      )
      clearTimeout(entry.timeoutId)
      entry.timeoutId = null
      entry.startedAt = null
    })
  }, [])

  const resumeTimeouts = useCallback(() => {
    timeoutEntriesRef.current.forEach((entry) => {
      if (entry.timeoutId !== null) {
        return
      }

      runTimeout(entry)
    })
  }, [runTimeout])

  useEffect(() => {
    return () => {
      clearAllTimeouts()
    }
  }, [clearAllTimeouts])

  useEffect(() => {
    function handleVisibilityChange() {
      if (typeof document === "undefined") {
        return
      }

      if (document.visibilityState === "hidden") {
        pauseTimeouts()
        return
      }

      resumeTimeouts()
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [pauseTimeouts, resumeTimeouts])

  useEffect(() => {
    function checkFlip(f) {
      if (f.v[0] === f.v[1]) {
        scheduleTimeout(() => {
          audio.result("match")
        }, 300)
        setMatch((currentMatches) => [...currentMatches, f.v[0]])
        setFlip({ i: [], v: [] })
      } else {
        if (!hasError) {
          setErrors((currentErrors) => currentErrors + 1)
          audio.result("error")
          setHasError(true)
        }
        scheduleTimeout(() => {
          setFlip({ i: [], v: [] })
          setHasError(false)
        }, 2000)
      }
    }

    if (flipping.i.length === 2) {
      checkFlip(flipping)
    }
  }, [flipping, scheduleTimeout, setMatch, setFlip, setErrors, hasError])

  function reshuffle() {
    console.log("useGame.js reshuffle()")
    clearAllTimeouts()
    randomChoose = []
    audio.result("shuffle")
    setFlip({ i: [], v: [] })
    setMatch([])
    setErrors(0)
    setHasError(false)
    scheduleTimeout(() => setDeck(genDeck(reduceDeck(deckItems))), 600)
  }

  function cardClick(value, index) {
    const { i, v } = flipping
    if (i.length < 2) {
      audio.play("flip")
      setFlip({ i: [...i, index], v: [...v, value] })
    }
  }

  const cards = deck.map(({ id, publicURL }, i) => {
    return (
      <Card
        key={i}
        bg={bg}
        onClick={() => cardClick(id, i)}
        value={id}
        image={publicURL}
        back={data.game.frontmatter.cardback.publicURL}
        matched={matches.includes(id)}
        flipping={flipping.i.includes(i)}
      />
    )
  })

  const finished = matches.length === deck.length / 2

  //return [cards, reshuffle, errors, elapsedTime, finished];
  return [cards, reshuffle, errors, finished]
}

export default useGame
